export const GoogleEvents = {
    CONVERSION: 'conversion'
};
export class GoogleAnalyticsService {
    static trackEvent(eventName, payload) {
        var _a;
        const trackingEnabled = (_a = window.FEATURES) === null || _a === void 0 ? void 0 : _a.tracking;
        const gtag = window.gtag;
        if (trackingEnabled && gtag) {
            gtag('event', eventName, payload);
        }
    }
}
